import { useState, useCallback } from 'react'
import { throttle } from 'throttle-debounce'

export default function useBoundingRect() {
  const [rect, setRect] = useState({})

  const ref = useCallback((node) => {
    const updateWidth = throttle(200, () => {
      if (!node) return
      setRect(node.getBoundingClientRect())
    })
    updateWidth()
    window.addEventListener('resize', updateWidth)
    window.addEventListener('load', updateWidth)
    return () => {
      window.removeEventListener('resize', updateWidth)
      window.removeEventListener('load', updateWidth)
    }
  }, [])

  return {
    ref,
    // It's not possible to spread a DOMRect object :(
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width,
    x: rect.x,
    y: rect.y,
  }
}
